import { render, staticRenderFns } from "./OtherIcon.vue?vue&type=template&id=9dd4f678&scoped=true"
import script from "./OtherIcon.vue?vue&type=script&lang=js"
export * from "./OtherIcon.vue?vue&type=script&lang=js"
import style0 from "./OtherIcon.vue?vue&type=style&index=0&id=9dd4f678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd4f678",
  null
  
)

export default component.exports